import * as React from "react";
import { appTheme } from "../../appTheme";
import { UniversalLink } from "../UniversalLink/UniversalLink";
import { normalizeRedocBadge } from "../../utils";
import { MenuItemTitle, Separator, ExternalIcon, StyledOperationBadge, MenuLabel, ArrowWrapper, DrilldownMenuItem } from "./styled.elements";
import { Arrow } from "../Arrow/Arrow";
export default function UserMenuItem(a) {
  var _a$item = a.item,
      g = _a$item.active,
      h = _a$item.expanded,
      i = _a$item.items,
      j = _a$item.link,
      k = _a$item.label,
      l = _a$item.type,
      m = _a$item.httpVerb,
      n = _a$item.external,
      o = _a$item.target,
      p = _a$item.menuStyle,
      q = _a$item.icon,
      r = _a$item.sublabel,
      b = a.depth,
      c = a.isLast,
      d = a.isExpanded,
      e = a.isAlwaysExpanded,
      f = a.className,
      s = React.useRef(null);
  React.useLayoutEffect(function () {
    if (a.item.active) {
      var _a = s.current;
      if (!_a) return;

      _a.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  });
  var t = i && 0 < i.length,
      u = d ? "down" : "right",
      v = "drilldown" === p,
      w = "separator" === l ? /*#__PURE__*/React.createElement(Separator, {
    depth: b,
    ref: s,
    className: f
  }, k) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItemTitle, {
    ref: s,
    expanded: !!h && t,
    active: g,
    last: !!c,
    depth: b,
    onClick: a.onClick,
    isAlwaysExpanded: !!e,
    "data-cy": "sidebar-item-" + k,
    hasChildren: t,
    isDrilldown: v,
    className: f
  }, t && !v && !e && /*#__PURE__*/React.createElement(ArrowWrapper, null, /*#__PURE__*/React.createElement(Arrow, {
    color: appTheme.sidebar.caretColor,
    direction: u,
    width: appTheme.sidebar.caretSize + "px",
    height: appTheme.sidebar.caretSize + "px",
    "data-cy": "arrow"
  })), m && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledOperationBadge, {
    type: m
  }, normalizeRedocBadge(m))), v ? /*#__PURE__*/React.createElement(DrilldownMenuItem, {
    icon: q,
    label: k,
    sublabel: r
  }) : /*#__PURE__*/React.createElement(MenuLabel, null, k), n && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExternalIcon, null))));
  return j ? /*#__PURE__*/React.createElement(UniversalLink, {
    to: j,
    target: o || void 0,
    external: n || void 0
  }, w) : w;
}